export default __webpack_public_path__ + "static/media/CafeSign.f7ad277a.jpeg";